import { useAddToast } from '../../../../../../contexts/ToastContext';
import { put } from '../../../../../../redux/api';
import type { ClaimSamlDomainRequest } from '../../../../../../../typings/api';

type ClaimSAMLDomainResponse = { redirectUrl: string };

const useClaimSAMLDomain = (organizationId: number) => {
  const addToast = useAddToast();
  const claimSAMLDomain = (payload: ClaimSamlDomainRequest) => {
    try {
      return put<ClaimSamlDomainRequest, ClaimSAMLDomainResponse>(`/api/organizations/${organizationId}/saml-domain`, payload);
    } catch (error: unknown) {
      addToast({ type: 'error', content: 'Failed to claim SAML domain' });
      throw error;
    }
  };

  return {
    claimSAMLDomain,
  };
};

export default useClaimSAMLDomain;
